import React from "react";
import links from "../utils/links";
import { NavLink } from "react-router-dom";
import { useAppContext } from "../context/appContext";
import { isEqual } from "lodash";

const NavLinks = ({ toggleSidebar, user }) => {
  const state = useAppContext();

  return (
    <div className="nav-links">
      {links.map((link) => {
        const { text, path, id, icon, maxUserRolesId, dbTables } = link;
        const diffTables = dbTables?.filter((table) => {
          return !isEqual(state[table], state[table + "Original"]);
        });
        
        if (user?.user_roles_id <= maxUserRolesId) {
          return (
            <NavLink to={path} key={id} className={"nav-link"} onClick={toggleSidebar}>
              <span className="icon">{icon}</span>
              {text}
              {diffTables?.length > 0 && !state.isLoading && <div className="unsaved-dot" title="Unsaved changes" />}
            </NavLink>
          );
        }
      })}
    </div>
  );
};
export default NavLinks;
